import React, { Component } from 'react';
import classnames from 'classnames';
import './index.scss';
import Preview from '../Preview';

class Design extends Component {
  
    constructor(props){
      super(props);
      this.state ={
        selected:(props.props.require_email)?'always':'never',
        message:''
      }
    }

    changeSetting = (values) =>{
      this.setState({
        selected:values
      })
      console.log(values,(values==='always')?true:false);
      this.props.onValueChange({target:{value:(values==='always')?true:false}},"require_email")
    }

    onMessageChange = (event) =>{
      this.setState({
        message:event.target.value
      })
    }

  checkForSave = ()=>{
      const { selected }=this.state;
      const { props } = this.props;
      if(selected==='never'){
        return false;
      }else if(!props.email_capture_message || props.email_capture_message.trim().length<1){
        return true;
      }
    }
  onCancelClick =()=>{
    this.props.onCancel();
    setTimeout(()=>{
      this.setState({
        selected:(this.props.props.require_email)?'always':'never',
      })
    },100);
  }

    render(){
      const {selected}=this.state;
      const {props ,onValueChange, onSave,onCancel,auth} = this.props;
      const {global_logo_file, business_name, assistant_name, actioncolor, brandcolor ,email_capture_message, greetings} = props;
      return (<div className="design">
                <div className="design-config">
                    <div className="title">
                    Ask your visitor for email when starting a live chat:
                    </div>
                    <div className="selection">
                      <div className="radio-section">
                          <div className="radio-group" onClick={()=>this.changeSetting('never')}>
                              <div className="radio-outer">
                                <div className={classnames({'radio-inner':selected==='never'})}> </div>
                              </div>
                              <div className="disp-value">Never</div>
                          </div>
                          <div className="description">Allows visitors to start conversation at any time</div>
                      </div>
                      <div className="radio-section">
                        <div className="radio-group" onClick={()=>this.changeSetting('always')}>
                            <div className="radio-outer">
                                <div className={classnames({'radio-inner':selected==='always'})}> </div>
                            </div>
                            <div className="disp-value">Always</div>
                        </div>
                        <div className="description">Please note that selecting 'Always' reduces web chat conversation volume</div>
                      </div>
                    </div>
                    {selected==='always' &&
                    <div className="email-capture">
                        <div className="title">Email capture text</div>
                        <div className="input-conatiner">
                            <textarea className="input" value={email_capture_message} onChange={(e)=>onValueChange(e,'email_capture_message')} disabled={selected!=='always'}/>
                        </div>
                    </div>
                    }
                    <div className="action-area">
                      <div>
                          <button type="button" className="btn btn--primary btn--md first-button" onClick={(e)=>onSave(e,'email')} disabled={this.checkForSave()}>
                              SAVE
                          </button>
                          <button type="button" className="btn btn--link button-cancel" onClick={this.onCancelClick}>
                              Cancel
                          </button>
                      </div>
                    </div>
                </div>
               <Preview message={greetings} auth={auth} email_capture_message={email_capture_message} logo={global_logo_file} business_name={business_name} assistant_name={assistant_name} actioncolor={actioncolor} brandcolor={brandcolor} usermessage={false} emailInit={selected==='always'}/> 
              </div>)
    }
};

export default Design;
